import SanitySchema, { singletonSchemas } from '@/modules/sanity-studio/schemas';
import {
	pageStructure,
	singletonPlugin,
} from '@/modules/sanity-studio/plugins';
import { defineConfig } from 'sanity';
import { structureTool } from 'sanity/structure';
import { visionTool } from '@sanity/vision';

// import { presentationTool } from 'sanity/presentation';
import { SanityConfig } from '@/configs/sanity.config';
import {
	HomePageSchema,
	NavigationMenuSchema,
	PrivacyPolicyPageSchema,
	ShippingPolicyPageSchema,
	TermsOfServicePageSchema,
} from '@/modules/sanity-studio/schemas/singletons';

export const nextStudioConfig = defineConfig({
	basePath:  SanityConfig.basePath,
	projectId: SanityConfig.projectid,
	dataset:   SanityConfig.dataset,
	title:     SanityConfig.title,
	schema:    SanitySchema,
	plugins:   [
		structureTool({ structure: pageStructure(singletonSchemas) }),

		// presentationTool({ previewUrl: { draftMode: { enable: '/api/sanity/draft' } } }),
		singletonPlugin([
			HomePageSchema.name,
			NavigationMenuSchema.name,
			PrivacyPolicyPageSchema.name,
			ShippingPolicyPageSchema.name,
			TermsOfServicePageSchema.name,
		]),
		visionTool({ defaultApiVersion: SanityConfig.apiVersion }),
	],
});